import Immutable from 'immutable';

export interface DocumentUploadProgress {
  title: string;
  id: string;
  totalToUpload: number;
  totalUploaded: number;
  // Upload completion timestamp
  timestamp: number;
  error: string;
  canRetry: boolean;
}

const defaultValues: DocumentUploadProgress = {
  title: '',
  id: '',
  totalToUpload: 0,
  totalUploaded: 0,
  timestamp: 0,
  error: '',
  canRetry: false,
};

export const DocumentUploadProgressFactory = Immutable.Record(
  defaultValues,
  'DocumentUploadProgress'
);

export class BatchUploadProgress {
  totalToUpload: number;

  totalUploaded: number;

  processingRequestId: string;

  documentsProgress: DocumentUploadProgress[];

  constructor(
    totalToUpload: number,
    totalUploaded: number,
    processingRequestId: string,
    documentsProgress: DocumentUploadProgress[]
  ) {
    this.totalToUpload = totalToUpload;
    this.totalUploaded = totalUploaded;
    this.processingRequestId = processingRequestId;
    this.documentsProgress = documentsProgress;
  }
}
